import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import * as moment from 'moment';
import { UserProfileVerificationStatusTypes } from 'src/app/models/SystemEnums';
import { UserWebViewModel } from 'src/app/models/User';
import { ServerService } from 'src/app/services/server/server.service';

@Component({
    selector: 'app-user-detail',
    templateUrl: './user-detail.component.html',
    styleUrls: ['./user-detail.component.scss'],
    standalone: false
})
export class UserDetailComponent {
  userItem: UserWebViewModel = {} as UserWebViewModel;
  reason: string = '';
  verifyDialogOpened: boolean = false;
  unverifyDialogOpened: boolean = false;
  readonly defaultUserImage = 'assets/images/static/user.png';
  constructor(
    private router: Router,
    private server: ServerService,
    private notify: NotificationsService
  ) {
    const nav = this.router.getCurrentNavigation();
    const userState = nav?.extras?.state?.['user'] ?? history.state?.user;
    if (userState) {
      const json = JSON.stringify(userState);
      this.userItem = JSON.parse(json);
    }
  }

  ngOnInit(): void {
    if (!this.userItem || !this.userItem.userId) {
      this.notify.warn('Could not load user details.');
      this.goBack();
      return;
    }

    this.onLoadUser();
  }

  onLoadUser() {
    this.server.onGetAllAppUsers(this.userItem.userId).subscribe(
      {
        next: (res) => {
          if (res.success === true) {
            this.userItem = res.obj[0];

            this.onProcessPictures();
          }
          else {
            this.notify.error(res.message);
          }
          this.verifyDialogOpened = false;
          this.unverifyDialogOpened = false;
        },
        error: (err) => {
          this.notify.error('An error has occured');

        }
      }
    )
  }

  onProcessPictures() {
    this.userItem.profilePicture = this.server.ProcessProfilePicUrl(
      this.userItem.profilePicture,
      true
    );
    this.userItem.profilePicture2 = this.server.ProcessProfilePicUrl(
      this.userItem.profilePicture2,
      true
    );
    this.userItem.profilePicture3 = this.server.ProcessProfilePicUrl(
      this.userItem.profilePicture3,
      true
    );
    this.userItem.profilePicture4 = this.server.ProcessProfilePicUrl(
      this.userItem.profilePicture4,
      true
    );

    this.userItem.confirmVerificationPhoto = this.server.ProcessProfilePicUrl(
      this.userItem.confirmVerificationPhoto,
      true, false
    );


    this.userItem.verificationPhoto = this.server.ProcessProfilePicUrl(this.userItem.verificationPhoto, true, false);
  }

  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.src = this.defaultUserImage;
  }

  displayValue(value: any) {
    if (value === null || value === undefined || value === '') {
      return 'Not provided';
    }
    return value;
  }

  boolLabel(value: any) {
    return value ? 'Yes' : 'No';
  }

  formatLastSeen(value: string | null | undefined) {
    if (!value) {
      return 'Not available';
    }

    const parsed = moment(value);
    if (!parsed.isValid()) {
      return 'Not available';
    }

    return parsed.fromNow();
  }

  goBack() {
    this.router.navigateByUrl('/users');
  }

  closeVerification(value) {


    if (value == 'yes') {

      this.server.onVerifyProfile(this.confirmVerificationPhoto, this.userItem.userId).subscribe(
        {
          next: (res) => {
            if (res.success === true) {
              this.userItem.verificationStatus = UserProfileVerificationStatusTypes.verified;

              this.onLoadUser();
            }
            else {
              this.notify.error(res.message);
            }
            this.verifyDialogOpened = false;
            this.unverifyDialogOpened = false;
          }
          ,
          error: (err) => {
            this.notify.error('An error has occured');
            console.log(err);
            this.verifyDialogOpened = false;
            this.unverifyDialogOpened = false;
          }
        }
      )
    }
    else {


      this.verifyDialogOpened = false;
      this.unverifyDialogOpened = false;
    }
  }

  confirmVerificationPhoto: string;

  onVerify(photoCode: string) {

    this.verifyDialogOpened = true;

    let photoCodeOnly = photoCode.split('/');
    var len = photoCodeOnly.length;
    let p = photoCodeOnly[len - 1];

    this.confirmVerificationPhoto = p;


  }

  onUnverify() {
    this.unverifyDialogOpened = true;
  }

  onUnverifyDialogClosed(value) {

    if (value === 'yes') {

      if (this.reason === null || this.reason.length < 5) {
        this.notify.warn('please provide a valid reason');
        return;
      }

      this.server.onUnVerifyProfile(this.userItem.userId, this.reason).subscribe(
        {
          next: (res) => {
            if (res.success === true) {

              this.onLoadUser();
            }
            else {
              this.notify.error(res.message);
            }
            this.verifyDialogOpened = false;
          }
          ,
          error: (err) => {
            this.notify.error('An error has occured');
            console.log(err);
            this.verifyDialogOpened = false;
          }
        }
      )
    }
    else {
      this.unverifyDialogOpened = false;
    }
  }
}
